import React, { memo, useState, useEffect } from "react";
import styled from "styled-components";
import icon_info_dialog_red from "assets/icon_info_dialog_red.svg";
import { useTranslation } from "react-i18next";

const ModalNotifyWrongOtp = memo(
  ({ className, onCancel, isOpen, isPassword }) => {
    const { t } = useTranslation("translation");
    const [date, setDate] = useState("");

    useEffect(() => {
      formatDate();
    });

    const formatDate = () => {
      const today = new Date();

      const date =
        (today.getDate() < 10 ? "0" + today.getDate() : today.getDate()) +
        "-" +
        (parseInt(today.getMonth() + 1) < 10
          ? "0" + parseInt(today.getMonth() + 1)
          : parseInt(today.getMonth() + 1)) +
        "-" +
        today.getFullYear();
      setDate(date);
    };

    return (
      <div className={className}>
        <div className=" text-center relative justify-center items-center">
          <div className="flex justify-center items-center mb-5 mt-4">
            <img
              src={icon_info_dialog_red}
              className="img-menu-logo w-16 mt-5"
              alt="warning"
            />
          </div>
          <div className="text-center font-700 fs-16 ml-4 mr-4">
            {isPassword ? t("errorPassword") : t("titleWrongOtp")}
          </div>
          {!isPassword && (
            <div>
              <div className="flex ml-4 mr-4 text-content mt-1 justify-center items-center">
                <div className="text-center text-content">
                  {t("contentWrongOtp")}
                </div>
                <div className="text-center text-bold ml-1">23:59</div>
                <div className="text-center text-content ml-1">
                  {t("contentWrongOtp1")}
                </div>
              </div>
              <div className="text-center text-bold ml-1">{date}</div>
            </div>
          )}
          {isPassword && (
            <div className="text-center text-content ml-3 mr-3">
              {t("errorContentPassword")}
            </div>
          )}
          <div className=" w-full flex justify-center items-center">
            <div
              onClick={onCancel}
              className=" text-center flex justify-center items-center mt-3 btn mb-4 w-full"
            >
              <div className="text_yes">{t("textReLogin")}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default styled(ModalNotifyWrongOtp)`
  .text-content {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808080;
    font-family: "Manrope", sans-serif;
  }
  .text-bold {
    line-height: 20px;
    font-weight: 700;
    font-size: 14px;
    color: #1a1a1a;
    font-family: "Manrope", sans-serif;
  }
  .btn {
    width: 190px;
    height: 50px;
    border-radius: 6px;
    background: #1a1a1a;
  }
  .text_yes {
    line-height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    font-family: "Manrope", sans-serif;
  }
`;
